module.exports = __webpack_public_path__ + "img/h2.75943857.jpg";